import type { Observable } from 'rxjs/Observable';
import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import { fetchJson$ } from '@atlassian/jira-servicedesk-common/src/utils/fetch/index.tsx';
import type { AppLink } from '../../../../types.tsx';

export type AppLinksResponse = {
	appLinks: AppLink[];
};

export type AppLinkResponse = AppLink;

export const fetchAppLinkNoEyeball = (projectKey: string): Observable<AppLinksResponse> =>
	fetchJson$(`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence`);

export const fetchCurrentAppLinkNoEyeball = (projectKey: string): Observable<AppLinkResponse> =>
	fetchJson$(
		`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`,
	);

export const fetchCurrentAppLinkNoEyeballV2 = (projectKey: string): Promise<AppLinkResponse> =>
	fetchJson(
		`/rest/servicedesk/noeyeball/1/${encodeURIComponent(projectKey)}/applinks/confluence/current`,
	);
